import React from "react";
import "./index.css";
import Typical from "react-typical";
// import { NavLink} from "react-router-dom";
import Home from "./Home"
import About from "./About"
import Skill from "./Skill";
import Project from "./Project";
import Contact from "./Contact";
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import { NavLink, Switch, Route, Redirect,BrowserRouter } from "react-router-dom";

const SideMenu = () => {
  return (
    <>
    
    <section style={{backgroundColor:"#111111"}}>
      <div className="side-menu">
        <ul>
            <li><NavLink to="/home"><BubbleChartIcon style={{fontSize:"35px"}}/>Home</NavLink></li>
            <li><NavLink to="/about"><BubbleChartIcon style={{fontSize:"35px"}}/>About</NavLink></li>
            <li><NavLink to="/skill"><BubbleChartIcon style={{fontSize:"35px"}}/>Skill</NavLink></li>
            <li><NavLink to="/project"><BubbleChartIcon style={{fontSize:"35px"}}/>Project</NavLink></li>
            <li><NavLink to="/contact"><BubbleChartIcon style={{fontSize:"35px"}}/>Contact</NavLink></li>
            {/* <li>Home</li> */}
        </ul>
      </div>

      {/* <Home/> */}
      </section>
      <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        {/* <Route exact path="/service" component={Service} /> */}
        <Route exact path="/skill" component={Skill} />
        <Route exact path="/project" component={Project} />
        <Route exact path="/contact" component={Contact} />
        {/* <Route exact path="/side" component={SideMenu} /> */}
        {/* <Redirect to="/side" /> */}
      </Switch>
      </BrowserRouter>
    </>
  );
};

export default SideMenu;
